import { observer } from 'src/utils/mobx-react';
import { QuickPickViewState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import { useAppStateContext } from 'src/AppState/AppState';
import React from 'react';
import { MatchBetRow } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MatchBet/MatchBetRow';
import { MatchBetTitle } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MatchBet/MatchBet.style';
import { DateTime } from 'src_common/utils/time/time';

interface MatchBetPropsType {
    userId: number,
    quickPickState: QuickPickViewState
}

export const MatchBet = observer('MatchBet', (props: MatchBetPropsType) => {
    const appState = useAppStateContext();
    if (props.quickPickState.getSelectedEvent === null) {
        return null;
    }
    const event = props.quickPickState.getSelectedEvent;
    const competitionId = event?.competition;
    if (event === null || competitionId === undefined) {
        return null;
    }

    const competition = appState.websocketV2.getCompetitionModel(competitionId);
    const markets = props.quickPickState.marketFilterState.marketsForSelectedMarket;

    if (competition === null || markets === null) {
        return null;
    }

    const startTime = DateTime.from(event.timeSettingsStartTime)?.tz(props.quickPickState.timeFilterState.timezone);

    return (
        <div>
            <MatchBetTitle>{competition.name} - {startTime?.format('HH:mm')}</MatchBetTitle>
            <div>
                {markets.map(market => (
                    <MatchBetRow
                        key={market.id}
                        userId={props.userId}
                        marketId={market.id}
                        quickPickState={props.quickPickState}
                    />)
                )}
            </div>
        </div>
    );
});
